import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import breakpoint from './breakpoint';
import auth from './auth';
import lightbox from './lightbox';
import accountPage from '../components/AccountPage/reducers';
import paymentPage from '../components/PaymentPage/reducers';
import emailConfirmationPage from '../components/EmailConfirmationPage/reducers';
import paymentWizard from '../components/PaymentPage/PaymentWizard/reducers';
import tabs from './tabs';
import faq from './faq';
import matrix from './matrix';
import subscriptions from './subscriptions';
import userInfo from './userInfo';
import userServices from './userServices';
import confirmation from './confirmation';
import campaignOfferInfo from './campaignOfferInfo';

export default combineReducers({
  router,
  form,
  auth,
  lightbox,
  breakpoint,
  accountPage,
  paymentPage,
  emailConfirmationPage,
  paymentWizard,
  tabs,
  faq,
  matrix,
  subscriptions,
  userInfo,
  userServices,
  confirmation,
  campaignOfferInfo,
});
